<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h2>Edit Work Abroad Request</h2>
        <br/>
        <div fxLayout="row" fxLayoutAlign="center">
            <mat-card>
                <mat-card-content>
                    <table class="top-tables">
                        <div>
                            <tr>
                                <th id="name" class="top-table-headings">Employee Name:</th>
                                <td>{{selectedData.value.firstName}} {{selectedData.value.lastName}}</td>
                            </tr>
                            <tr>
                                <th id="gmin" class="top-table-headings">GMIN:</th>
                                <td>{{selectedData.value.gmin}}</td>
                            </tr>
                            <th id="start-date">Work Abroad Start Date:</th>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-label>Enter start date</mat-label>
                                    <input matInput [matDatepicker]="pickerStartDate" [formControl]="startDate" readonly/>
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerStartDate></mat-datepicker>
                                </mat-form-field>
                            </td>
                            <tr>
                                <th id="endDate" class="top-table-headings">Work Abroad End Date:</th>
                                <td>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Enter end date</mat-label>
                                        <input matInput [matDatepicker]="pickerEndDate" [formControl]="endDate" readonly/>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerEndDate></mat-datepicker>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th id="first-day-back" class="top-table-headings">First Day Back in Ireland:</th>
                                <td>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Enter first back date</mat-label>
                                        <input matInput [matDatepicker]="pickerFirstDayBack" [formControl]="firstDayBack" readonly/>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerFirstDayBack"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerFirstDayBack></mat-datepicker>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th id="last-day-working" class="top-table-headings">Last Day Working:</th>
                                <td>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Enter last day working date</mat-label>
                                        <input matInput [matDatepicker]="pickerLastDayWorking" [formControl]="lastDayWorking" readonly/>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerLastDayWorking"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerLastDayWorking></mat-datepicker>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th id="work-abroad-days" class="top-table-headings">Work Abroad Days:</th>
                                <td>
                                    <mat-form-field appearance="outline">
                                        <input matInput type="number" id="numberOfWorkAbroadDays" [(ngModel)]="selectedData.value.numberOfWorkAbroadDays" name="numberOfWorkAbroadDays"
                                               [valueAsNumber]="selectedData.value.numberOfWorkAbroadDays"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th id="carryOver" class="top-table-headings">Carry Over:</th>
                                <td>
                                    <mat-form-field appearance="outline">
                                        <input matInput type="number" id="negativeCarryOver" [(ngModel)]="selectedData.value.workAbroadNegativeCarryOver" name="negativeCarryOver"
                                               [valueAsNumber]="selectedData.value.workAbroadNegativeCarryOver"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </div>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>
        <br/>
        <div style="margin-bottom: 5%;" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12">
            <button mat-raised-button (click)="close()">Cancel
            </button>
            <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="edit(this.workAbroad)" #form="ngForm">
                <button mat-raised-button color="primary" [disabled]="!form.form.valid">Submit</button>
            </form>
            <br/>
        </div>
    </div>
</mat-dialog-content>
